// const json = '{"uneDateCorrecte":"2024-07-02", "uneDateFausse":"2024-13-02", "encoreUneDateFausse":"2024-07-38", "pasUneDate":"2024-ZZZZ-02", "unChamp":"maison"}'

// const object = {
//   uneDateCorrecte: new Date('2024-07-02T00:00:00.000Z'),
//   pasUneDate: '2024-ZZZZ-02',
//   unChamp: 'maison'
// }

export function extractDate(key: any, value: any) {
  const dateDetect = /(\d{4})-(\d{2})-(\d{2})/
  if (key && typeof value === 'string' && dateDetect.exec(value)) {
    const date = new Date(value)
    if (!isNaN(date.getTime())) {
      return date
    }
    return value
  }
  return value
}

export function convertDate(key: any, value: any) {
  const dateDetect = /(\d{4})-(\d{2})-(\d{2})/
  if (key && typeof value === 'string' && dateDetect.exec(value)) {
    return value.split('T')[0]
  }
  return value
}

export function parseSearchQuery(value: string) {
  const regex = /"([^"]+)"|([^\s]+)|"/gi
  const found = value.match(regex)
  const search: string[] = []
  found?.forEach((x: string) => search.push(x.split('"').length - 1 === 1 ? x : x.replace(/"/g, '')))
  return search
}

export function formatSearchQuery(value: string[]) {
  return value.map((x) => (x.indexOf(' ') >= 0 ? '"' + x + '"' : x)).join(' ')
}

// export function parse() {
//   const parsed = JSON.parse(json, extractDate)
//   console.log("PARSED =>", parsed)
// }

// export function stringify() {
//   const stringified = JSON.stringify(object, convertDate)
//   console.log("STRINGIFY =>", stringified)
// }

// parse()
// stringify()
